import { twMerge } from "tailwind-merge"
import { InputSizeOptions } from "../form/Forms"

const Label: React.FC<React.LabelHTMLAttributes<HTMLLabelElement> & InputSizeOptions> = ({
  displaysize = "regular",
  className,
  ...props
}) => {
  const styleClass =
    displaysize === "regular"
      ? "text-[1rem] md:text-[1.125rem] font-bold leading-1.5 mb-[1.25rem] md:mb-[1.5rem]"
      : "text-lg md:text-lg font-regular leading-1 mb-[1rem] md:mb-[1]"

  return <label className={twMerge(styleClass, className)} {...props} />
}

export default Label
